import { Neuron, NeuronProvider as Provider, SPAConfig } from "@sphtech/neuron";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

Neuron.default.setConfig({});

export default function NeuronProvider({ children }: Props): ReactNode {
  // Disable Neuron in CUE preview
  if (
    typeof window !== "undefined" &&
    window.location.search.includes("preview_token=")
  ) {
    return children;
  }
  const neuronConfig: SPAConfig = {
    sessionApiUrl: import.meta.env.VITE_NEURON_API_URL,
    sessionApiToken: import.meta.env.VITE_NEURON_API_TOKEN,
    segmentsApiUrl: import.meta.env.VITE_SEGMENTO_API_URL,
    extends: (import.meta.env.VITE_NEURON_EXTENDS || "").split(","),
  };

  return <Provider config={neuronConfig}>{children}</Provider>;
}
